import { useHistory } from 'react-router-dom';
import { Fragment, useMemo } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLanguage } from '@hilma/netina2all';

import { useI18n, useSettings, useTranslateTexts } from '../hooks';
// import { Button } from '../components';
import { steps } from '../constants';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const FlowChart: React.FC = () => {
	const language = useLanguage();
	const alts = useI18n(i18n => i18n.alts);
	const stepAlts = useTranslateTexts<string[]>(steps.map(step => step.alt));
	const stepDescriptions = useTranslateTexts<string[]>(steps.map(step => step.homePageDescriptions ?? ''));
	const homePageText = useI18n(i18n => i18n.homePageText);
	const settingsCtx = useSettings();
	const mediaQuery = useMediaQuery('(min-width: 800px)');
	const history = useHistory();

	const classes = useStyles();

	const alt = useMemo(() => {
		const { chooseKit, pickAssociation, charityProceeds } = homePageText.flowchart;

		return [chooseKit, pickAssociation, charityProceeds].join(', ');
	}, [homePageText])

	return (
		<title id='flow-chart-and-button' className={classes.daddy}>
			{
				// settingsCtx.showPurchaseButton ? <>
				// 	<Button onClick={() => history.push(`/${language}/purchase`)}>
				// 		<img alt={alt} className={classes.fullWidth} src={`/lulav-icons/${mediaQuery ? 'desktop' : 'mobile'}-banner.png`} />
				// 	</Button>
				// </> :

				<div id='flow-chart-container' >
					{steps.map((step, index) =>
						step.homePageDescriptions ?
							<div key={index} className='flow-chart-item' >
								{index !== 0 ?
									<div className='flow-chart-arrow'
										style={language === 'he' ? { transform: 'rotate(0deg)' } : { transform: 'rotate(180deg)' }}
									>
										<img width='100%' src='/lulav-icons/arrow.svg' alt={alts.arrow} />
									</div>
									: null}
								<div key={index} className='flow-chart-item'>
									<div className='flow-chart-image-and-text' style={language === 'he' && mediaQuery ? { width: '130px', padding: '0 30px' } : {}}>
										<img src={step.imagePath} alt={stepAlts[index]} />
										<div>{stepDescriptions[index]}</div>
									</div>
								</div>
							</div> :
							<Fragment key={index}></Fragment>
					)}
				</div>
			}
		</title>
	);
}

export default FlowChart;

const useStyles = makeStyles(theme => ({
	fullWidth: {
		maxWidth: '100vw',
		width: '100vw',
		padding: 0,
	},
	daddy: {
		padding: '25px 0 0 !important',
		[theme.breakpoints.down(801)]: {
			maxWidth: '100vw',
			padding: '0 !important',
			'& button': {
				padding: '0 !important'
			}
		}
	}
}))